<template>
    <c-dialog ref="dialog" mode="slide" width="50vw" :button="false">
        <div class="m-log-content">
            <div v-if="productInfo || productCode" class="m-log-head">
                <span v-if="productInfo">{{productInfo}}</span>
                <span v-if="productCode" class="m-log-code">背贴码：{{productCode}}</span>
            </div>
            <c-title>借出记录</c-title>
            <c-table ref="list" border :paging="false">
                <c-table-column label="借货人" name="borrower_name" width="70"></c-table-column>
                <c-table-column label="同行价" width="100">
                    <template #default="{data}">
                        <span style="color: #e53e3e;">{{formatPrice(data.market_price)}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="借出时间" name="lend_date" width="120"></c-table-column>
                <c-table-column label="归还时间" name="return_date" width="120"></c-table-column>
                <c-table-column label="借出时长" width="80">
                    <template #default="{data}">
                        {{data.lend_days !== null && data.lend_days !== undefined ? data.lend_days + '天' : '-'}}
                    </template>
                </c-table-column>
                <c-table-column label="状态" width="70">
                    <template #default="{data}">
                        <c-state dict="saleReturnStateDic" :value="data.return_state"></c-state>
                    </template>
                </c-table-column>
                <c-table-column label="操作人" name="operator_name" width="70"></c-table-column>
            </c-table>
        </div>
    </c-dialog>
</template>

<script>
export default {
    name: 'erpSaleLendLog',

    data() {
        return {
            productInfo: '',
            /**背贴码：列表行带入，与商品名一并展示*/
            productCode: ''
        };
    },

    methods: {
        /*********打开弹框（data=运营端商品列表行，按商户切租户查借出记录）**********/
        open(data = {}) {
            this.productInfo = data.product_info || '';
            this.productCode = data.produce_unique_code || '';
            this.$refs.dialog.open({title: '借出记录'});
            this.$nextTick(() => {
                this.$refs.list.load({
                    url: '/sale/lend/ops/listByProduct',
                    data: {
                        merchant_id: data.saas_id,
                        product_id: data.id
                    }
                });
            });
        },

        /*********格式化价格**********/
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        }
    }
};
</script>

<style lang="stylus" scoped>
.m-log-content
    padding 20px

.m-log-head
    padding 10px 0 16px
    font-size 18px
    font-weight 600
    color #333
    text-align center

    /*背贴码单独一行展示，不与商品名挤在同一行；与商品名行拉开行距*/
    .m-log-code
        display block
        margin-top 8px
        line-height 1.4
        font-size 14px
        font-weight normal
        color #666
</style>
